import { Accordion, AccordionDetails, AccordionSummary, Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Typography, useTheme } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useMemo } from "react";
import useMobileScreen from "../../lib/useMobileScreen";

export default function ListaAcoesRapidas({
    items,
    fullHeight = true,
    scrollable = false,
    height = '100%'
}: ListaAcoesRapidasProps) {

    const theme = useTheme();
    const telaMobile = useMobileScreen()

    const ListItems = useMemo(() => {
        const permittedItems = items.filter((item) => Boolean(item.havePermission));
        const hasPermittedItems = permittedItems.length > 0;

        return (
            <List sx={{
                height: height,
                overflowY: scrollable ? 'scroll' : 'hidden'
            }}>
                {
                    hasPermittedItems ? (
                        permittedItems.map((item, index) => (
                            <ListItem key={index} disablePadding>
                                <ListItemButton onClick={item.action} disabled={item.disabled}>
                                    <ListItemIcon>
                                        {item.icon}
                                    </ListItemIcon>
                                    <ListItemText style={{ color: theme.palette.primary.main }} primary={item.label} />
                                </ListItemButton>
                            </ListItem>
                        ))
                    ) : (
                        <ListItem>
                            <ListItemText
                                secondary="Não há ações disponíveis no momento."
                            />
                        </ListItem>
                    )
                }
            </List>
        )
    }, [items, theme, height, scrollable])

    if (telaMobile) return (
        <Accordion>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
            >
                <Typography variant='h6'>Ações rápidas</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ padding: 0 }}>
                {ListItems}
            </AccordionDetails>
        </Accordion>
    )
    return (
        <Box component={Paper} style={{ height: fullHeight ? '100%' : 'unset'}}>
            <Typography variant='h6' p={2}>Ações rápidas</Typography>
            {ListItems}
        </Box>
    )
}

interface ListaAcoesRapidasProps {
    items: Array<TItemAcaoRapida>,
    fullHeight?: boolean
    scrollable?: boolean
    height?: string
}

export type TItemAcaoRapida = {
    label: string,
    icon: React.ReactNode,
    action: () => void,
    havePermission?: boolean,
    disabled?: boolean
}